import React from 'react';

import Presentacion from './comps/Presentacion';
import PrimeraParte from './comps/PrimeraParte';
import Solicitar from './comps/Solicitar';
import Carrusel from '../comun/Carrusel';
import MasProductos from './comps/MasProductos';

const syncFlowDeclarative = ({ t }) => {
  return (
    <>
      <Presentacion t={t} />
      <PrimeraParte t={t} />
      <Solicitar t={t} />
      <Carrusel t={t} />
      <MasProductos t={t} />
    </>
  );
};

export default syncFlowDeclarative;
